module.exports = __webpack_public_path__ + "static/media/FullLogoDark.f8e4697f.png";